"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const createIconComponent_1 = require("../createIconComponent");
const pathProps = {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
};
exports.default = createIconComponent_1.default("ImageOutlined", React.createElement(React.Fragment, null,
    React.createElement("path", Object.assign({}, pathProps, { d: "M20.3,19.9H3.7c-1.4,0-2.5-1.1-2.5-2.5V6.6c0-1.4,1.1-2.5,2.5-2.5h16.6c1.4,0,2.5,1.1,2.5,2.5v10.8\n\tC22.8,18.8,21.7,19.9,20.3,19.9z" })),
    React.createElement("path", Object.assign({}, pathProps, { d: "M9.8,19.7c2.8-2.7,4.6-4.5,4.6-4.5l1.2,1.1l2.4-5.2l4.7,7.1" })),
    React.createElement("path", Object.assign({}, pathProps, { d: "M6.7,12.4c1.6,0,2.9-1.3,2.9-2.9c0-1.6-1.3-2.9-2.9-2.9c-1.6,0-2.9,1.3-2.9,2.9C3.8,11.1,5.1,12.4,6.7,12.4z" }))));
//# sourceMappingURL=ImageOutlined.js.map